import React from 'react';
import {useSearchParams} from 'react-router-dom';
import {AssetsBrowserShell} from 'src/app/assets/AssetsBrowserShell';
import {
  assetTreeRootId,
  toAssetListFilter,
} from 'src/app/assets/assetTreeBrowserState';
import {SidebarLinkAssets} from 'src/app/layout/Sidebar/SidebarLinksConfig';
import {PageHeader} from 'src/design/organisms/PageHeader';
import {assetDocumentTitle} from 'src/pages/Modules/Assets/assetHelpers';
import {AssetsTable} from 'src/pages/Modules/Assets/AssetList/components/AssetsTable';
import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';
import {ContentWrapper} from 'src/app/layout/ContentWrapper';

import {ModuleEnum, PermissionOperationEnum} from 'src/api/ProactApiClient';
import {PathUtility} from 'src/shared/constants/PathBuilder';
import {routeRegistry} from 'src/pages/RouteRegistry';

const AssetListPage: React.FC = () => {
  useSetDocumentTitle(assetDocumentTitle);
  const [searchParams] = useSearchParams();
  const requestedNodeId = searchParams.get('node') ?? undefined;
  const {parentId} = toAssetListFilter(requestedNodeId);
  const selectedId =
    parentId && requestedNodeId ? requestedNodeId : assetTreeRootId;

  return (
    <ContentWrapper>
      <AssetsBrowserShell selectedId={selectedId}>
        <PageHeader>
          <PageHeader.Title
            icon={SidebarLinkAssets.icon}
            subtitle="Manage equipment and locations">
            Assets
          </PageHeader.Title>
        </PageHeader>
        <AssetsTable parentId={parentId} />
      </AssetsBrowserShell>
    </ContentWrapper>
  );
};

export default AssetListPage;

// Register the routes with the new system
routeRegistry.registerPageRoute({
  backNavigation: 'page',
  path: PathUtility.Assets(),
  element: <AssetListPage />,
  module: ModuleEnum.Assets,
  operation: PermissionOperationEnum.View,
  isPrivate: true,
});
